import { create } from 'zustand';

export type TimerSnapshot = { entryId: string; taskId: string; taskTitle: string; startedAt: string; elapsedSeconds: number };

type TimerState = {
  snapshot: TimerSnapshot | null;
  lastTaskTitle: string | null;
  lastTaskId: string | null;
  elapsed: number;
  running: boolean;
  hydrate: (snapshot: TimerSnapshot | null) => void;
  tick: () => void;
};

/** Single source of truth for the live clock shown in dashboard, task cards and the modal. */
export const useTimer = create<TimerState>((set, get) => ({
  snapshot: null,
  lastTaskTitle: null,
  lastTaskId: null,
  elapsed: 0,
  running: false,
  hydrate: (snapshot) =>
    set((s) => ({
      snapshot,
      running: snapshot !== null,
      elapsed: snapshot?.elapsedSeconds ?? 0,
      lastTaskTitle: snapshot?.taskTitle ?? s.snapshot?.taskTitle ?? s.lastTaskTitle,
      lastTaskId: snapshot?.taskId ?? s.snapshot?.taskId ?? s.lastTaskId
    })),
  tick: () => {
    if (get().running) set((s) => ({ elapsed: s.elapsed + 1 }));
  }
}));
